function snakeToCamelCase(str) {
	return str.replace(/(_\w)/g, (match) => match[1].toUpperCase());
}

export function convertKeysToCamelCase(obj) {
	const result = {};

	for (const key in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, key)) {
			const newKey = snakeToCamelCase(key);
			const value = obj[key];

			if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
				result[newKey] = convertKeysToCamelCase(value);
			} else {
				result[newKey] = value;
			}
		}
	}

	return result;
}

function toSnakeCase(str) {
	return str.replace(/([A-Z])/g, "_$1").toLowerCase();
}

export function convertKeysToSnakeCase(obj) {
	let output = {};
	for (let i in obj) {
		if ((typeof obj[i]) === 'object' && obj[i] !== null) {
			output[toSnakeCase(i)] = convertKeysToSnakeCase(obj[i]);
		}
		else {
			output[toSnakeCase(i)] = obj[i];
		}
	}
	return output;
}